import { ChangeEvent, useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { LabeledInput } from "../../../Components/ConfigurationTab/LabeledInput";
import { UnitAdornment } from "../../../Components/ConfigurationTab/UnitAdornment";
import { Price, PRICE_UNIT } from "../../../price";
import { direction } from "../../lazertrader/types";
import { marginFromPrice, priceFromMargin } from "../shimuraiPrice";
import { ConfigTabState } from "../types";
import { formatPriceInput, price_regex } from "./priceField";
import { SETTINGS_LABEL_PLACEMENT } from "./constants";

export const ShimuraiPriceField = () => {
  const { values, setFieldValue } = useFormikContext<ConfigTabState>();

  const [draft, setDraft] = useState<string | undefined>(undefined);

  useEffect(() => setDraft(undefined), [values.algo_id]);

  const reference = Price.fromInput(values.reference_price);
  const side = direction(values.direction);

  const margin = Price.fromInput(values.margin_override);
  const derived =
    reference !== undefined && margin !== undefined
      ? String(priceFromMargin(margin, reference, side).yenPerKwh)
      : "";

  const onChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = formatPriceInput(e.target.value);
    setDraft(value);

    if (reference === undefined) {
      return;
    }
    const typed = Price.fromInput(value);
    setFieldValue(
      "margin_override",
      typed === undefined
        ? null
        : marginFromPrice(typed, reference, side).yenPerKwh
    );
  };

  return (
    <LabeledInput
      required={false}
      label="Price"
      labelPlacement={SETTINGS_LABEL_PLACEMENT}
      type="text"
      name="shimurai_price"
      disabled={reference === undefined}
      // Short enough for a third of the settings grid beside its unit.
      placeholder={reference === undefined ? "No ref." : undefined}
      value={draft ?? derived}
      onChange={onChange}
      onBlur={() => setDraft(undefined)}
      endAdornment={<UnitAdornment unit={PRICE_UNIT} />}
      inputProps={{
        pattern: price_regex,
        step: "10",
      }}
      autoComplete="off"
    />
  );
};
